import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { CandidateAdapter } from '@shared';
import { IsMobileViewService } from '@shared/services/is-mobile-view.service';
import {
  createTask,
  getTasksList,
  getTasksTotalPages,
  resetTasksState,
  Task,
  TasksAddEditService,
  TasksEntityType,
  tasksLoad,
} from 'mojo-tasks';

@Component({
  selector: 'mojo-tasks-page-container',
  templateUrl: './tasks-page.container.html',
  styleUrls: ['./tasks-page.container.scss'],
})
export class TasksPageContainerComponent implements OnChanges {
  @Input() entityType: TasksEntityType;
  @Input() entityId: number;
  @Input() sideDrawerConfiguration = false;
  @Input() showLine = true;
  @Input() width;
  @Input() candidate: CandidateAdapter;
  @Input() entityTitle: string;
  @Input() hasAnonymization = false;
  @Input() isExpandible = false;
  @Input() fromTalentPool = false;

  isPanelOpen = true;
  isAssignOpened = false;
  tasks$ = this.store.select(getTasksList);
  totalTasksPages$ = this.store.select(getTasksTotalPages);
  isMobileView$ = this.isMobileService.isMobileView$();
  constructor(
    private store: Store<{}>,
    private isMobileService: IsMobileViewService,
    private tasksAddEditService: TasksAddEditService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.entityType != null && this.entityId != null) {
      this.reloadTasks(this.entityType, this.entityId, this.hasAnonymization);
    }
  }

  private reloadTasks(entityType: TasksEntityType, entityId: any, hasAnonymization: boolean) {
    this.store.dispatch(resetTasksState());
    this.store.dispatch(
      tasksLoad({
        entityType,
        entityId,
        hasAnonymization,
      }),
    );
  }

  addTask(e: Event) {
    e.stopPropagation();
    this.tasksAddEditService.enableTaskAddMode();
  }

  createTask(payload: Partial<Task>) {
    this.tasksAddEditService.cancelAnyTaskMode();
    this.store.dispatch(
      createTask({
        payload: {
          ...payload,
          entityType: this.entityType,
          entityId: this.entityId,
          entityName: this.getEntityName(),
        },
        anonymization: this.hasAnonymization,
      }),
    );
  }
  getEntityName(): string {
    if (this.candidate?.name) {
      return this.candidate?.name;
    } else if (this.entityTitle) {
      return this.entityTitle;
    }

    return '';
  }

  toggleCard() {
    this.isPanelOpen = !this.isPanelOpen;
  }

  onScroll(pageNumber: number) {
    this.store.dispatch(
      tasksLoad({
        entityType: this.entityType,
        entityId: this.entityId,
        pageNumber,
        hasAnonymization: this.hasAnonymization,
      }),
    );
  }

  setIsAssignOpened(isAssignOpened) {
    this.isAssignOpened = isAssignOpened;
  }
}
